import { c as _c } from "react/compiler-runtime";
import { Grid, GridUnit } from '@hookdeck/theme';
import { StyledCard, StyledCardSection } from '../../../../../common/base/Card';
import Text from '../../../../../common/base/Text';
import { Div } from '../../../../../common/helpers/StyledUtils';
import React, { useContext } from 'react';
import { DashboardContext } from '../../../DashboardContext';
import APIMethodKeys from '../../../../../../client/APIMethodKeys';
import useSWR from 'swr';
import { GlobalContext } from '../../../../../contexts/GlobalContext';
import { OrbSubscription } from '../../../../../../typings/Orb.interface';
import Button from '../../../../../common/base/Button';
const ProjectThroughputs: React.FC<{
  subscription_details: OrbSubscription;
}> = t0 => {
  const $ = _c(26);
  const {
    subscription_details
  } = t0;
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  const {
    organization
  } = useContext(DashboardContext);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = APIMethodKeys.teams.listAll();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== HookdeckAPI.teams) {
    t2 = () => HookdeckAPI.teams.listAll();
    $[1] = HookdeckAPI.teams;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    data: teams
  } = useSWR(t1, t2);
  let T0;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[3] !== organization || $[4] !== subscription_details || $[5] !== teams) {
    const teams_for_current_organization = teams?.filter(team => team.organization_id === organization.id);
    const event_gateway_teams = teams_for_current_organization?.filter(_temp);
    const price_per_team = teams_for_current_organization?.reduce((obj, team_1) => {
      const interval = subscription_details.price_intervals?.find(pi => team_1.billing_meta.price_interval_id === pi.id);
      obj[team_1.id] = interval?.price.unit_config?.unit_amount || "0";
      return obj;
    }, {} as Record<string, string>);
    let t7;
    let t8;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = {
        justify: "space-between",
        align: "center"
      };
      t8 = {
        b: 4
      };
      $[11] = t7;
      $[12] = t8;
    } else {
      t7 = $[11];
      t8 = $[12];
    }
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <Div flex={t7} m={t8}><Div><Text bold={true} size="l" as="h2" m={0}>Projects throughput</Text><Text muted={true} m={0}>Throughput is managed on a per-project basis, and can be modified under a project’s Quotas tab.</Text></Div><Button outline={true} icon="rate_limit" to="/settings/project/quotas">Quotas</Button></Div>;
      $[13] = t6;
    } else {
      t6 = $[13];
    }
    T0 = StyledCard;
    let t9;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
      t9 = <GridUnit size={0.5}><Text muted={true} semi={true} size="xs" p={{
          x: 4,
          y: 1
        }} style={{
          lineHeight: "20px"
        }}>Project</Text></GridUnit>;
      $[14] = t9;
    } else {
      t9 = $[14];
    }
    let t10;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
      t10 = <GridUnit size={0.25}><Text muted={true} semi={true} size="xs" p={{
          x: 4,
          y: 1
        }} style={{
          lineHeight: "20px"
        }}>Rate</Text></GridUnit>;
      $[15] = t10;
    } else {
      t10 = $[15];
    }
    let t11;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
      t11 = {
        justify: "flex-end"
      };
      $[16] = t11;
    } else {
      t11 = $[16];
    }
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <StyledCardSection muted={true}><Grid>{t9}{t10}<GridUnit size={0.25}><Div flex={t11}><Text muted={true} semi={true} size="xs" p={{
                x: 4,
                y: 1
              }} style={{
                lineHeight: "20px"
              }}>Price</Text></Div></GridUnit></Grid></StyledCardSection>;
      $[17] = t3;
    } else {
      t3 = $[17];
    }
    t4 = price_per_team && event_gateway_teams?.map(team_2 => <StyledCardSection key={team_2.id}><Grid><GridUnit size={0.5}><Div flex={{
            align: "center"
          }}><Text size="s" ellipsis={true} p={{
              x: 4,
              y: 3
            }}>{team_2.name}</Text></Div></GridUnit><GridUnit size={0.25}><Text size="s" p={{
            x: 4,
            y: 3
          }}>{team_2.max_events_per_second} events per second</Text></GridUnit><GridUnit size={0.25}><Div flex={{
            justify: "flex-end"
          }} p={{
            x: 4,
            y: 3
          }}><Text size="s">${price_per_team[team_2.id]}</Text></Div></GridUnit></Grid></StyledCardSection>);
    t5 = price_per_team && <StyledCardSection flex={{
      justify: "space-between"
    }} p={{
      x: 4,
      y: 3
    }}><Text semi={true} size="s">Total throughput cost</Text><Text semi={true} size="s">${Object.values(price_per_team).reduce(_temp2, 0).toFixed(2)}</Text></StyledCardSection>;
    $[3] = organization;
    $[4] = subscription_details;
    $[5] = teams;
    $[6] = T0;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    T0 = $[6];
    t3 = $[7];
    t4 = $[8];
    t5 = $[9];
    t6 = $[10];
  }
  let t7;
  if ($[18] !== T0 || $[19] !== t3 || $[20] !== t4 || $[21] !== t5) {
    t7 = <T0>{t3}{t4}{t5}</T0>;
    $[18] = T0;
    $[19] = t3;
    $[20] = t4;
    $[21] = t5;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] !== t6 || $[24] !== t7) {
    t8 = <>{t6}{t7}</>;
    $[23] = t6;
    $[24] = t7;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  return t8;
};
export default ProjectThroughputs;
function _temp(team_0) {
  return team_0.type !== "outpost";
}
function _temp2(total, v) {
  return total + Number(v) as any;
}